import { useSession } from "@outschool/ui-auth";

import { useFeatureFlag } from "../lib/FeatureFlags";

const TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG =
  "teacher-unified-messaging-inbox";

export function useTeacherUnifiedMessaging() {
  return useFeatureFlag(TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG);
}

export function useSellerOrgUnifiedInbox() {
  const { currentUser } = useSession();
  const isTeacherUnifiedMessagingEnabled = useTeacherUnifiedMessaging();
  return (
    isTeacherUnifiedMessagingEnabled &&
    !!currentUser?.sellerOrg?.currentUserIsOwner
  );
}

/**
 * The org teacher whose inbox a seller org owner needs for a section that
 * teacher leads. The owner's own inbox doesn't include those sections.
 */
export function useSellerOrgViewAsTeacherUid(
  sectionLeaderUid: string | null | undefined,
): string | null {
  const { currentUser } = useSession();
  const isSellerOrgUnifiedInbox = useSellerOrgUnifiedInbox();
  return isSellerOrgUnifiedInbox &&
    !!sectionLeaderUid &&
    sectionLeaderUid !== currentUser?.uid
    ? sectionLeaderUid
    : null;
}
